import { isElementInViewport } from '@theme/utilities';

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = null;
    this.footer = null;
    this.ticking = false;
    // Réserve la hauteur du bloc quand il passe en position fixe,
    // pour éviter que le contenu de la page saute (layout shift).
    this.placeholder = null;

    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    this.form = this.closest('[data-ref="product-form"]');
    this.footer = document.querySelector('[data-ref="footer"]');

    this.#displayStickyAddToCart();

    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this.placeholder?.remove();
    this.placeholder = null;
  }

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.#displayStickyAddToCart();
      this.ticking = false;
    });
  }

  #displayStickyAddToCart() {
    if (isElementInViewport(this.form) || isElementInViewport(this.footer)) {
      if (this.dataset.active !== 'false') {
        this.dataset.active = 'false';
        this.classList.remove('color-scheme-1');
      }
      if (this.placeholder) this.placeholder.hidden = true;
    } else if (this.dataset.active !== 'true') {
      // Mesure faite pendant que le bloc est encore dans le flux (position statique).
      const height = this.offsetHeight;

      this.dataset.active = 'true';
      this.classList.add('color-scheme-1');

      this.#showPlaceholder(height);
    }
  }

  #showPlaceholder(height) {
    // Pas de réserve si le bloc ne passe pas réellement en position fixe (ex. fenêtre quick-add).
    if (!height || getComputedStyle(this).position !== 'fixed') {
      if (this.placeholder) this.placeholder.hidden = true;
      return;
    }

    if (!this.placeholder) {
      this.placeholder = document.createElement('div');
      this.placeholder.className = 'sticky-add-to-cart__placeholder';
      this.placeholder.setAttribute('aria-hidden', 'true');
      this.after(this.placeholder);
    }

    this.placeholder.style.height = `${height}px`;
    this.placeholder.hidden = false;
  }
}

if (!customElements.get('sticky-add-to-cart')) {
  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
